import type { ZudokuConfig } from "zudoku";

const config: ZudokuConfig = {
    metadata: {
        title: "Weeek Public API",
        favicon: "/favicon.png"
    },
  site: {
      title: "Weeek",
      showPoweredBy: false
  },
  navigation: [
    {
      type: "category",
      label: "Documentation",
      items: [
        {
          type: "category",
          label: "Getting Started",
          icon: "signpost",
          items: [
              {
                  "type": "doc",
                  "file": "getting_started",
                  "path": '/',
                  "label": "Getting started",
                  "icon": "file-text"
              },
              {
                  "type": "doc",
                  "file": "changelog",
                  "label": "Changelog",
                  "icon": "file-text"
              },
          ],
        },
      ],
    },
    {
      type: "link",
      to: "/api",
      label: "API References",
    },
  ],
   // redirects: [{ from: "/", to: "getting_started" }],
  apis: [
    {
      type: "file",
      input: "./apis/weeek.yaml",
      path: "/api",
        options: {
            examplesLanguage: "shell",
            expandAllTags: false,
        }
    }
  ],
};

export default config;
